import React, {ReactNode} from 'react';
import {Link} from "react-router-dom";

type NavBarItemLinkProps = {
    icon?: ReactNode,
    text?: string,
    to: string
}

function NavBarItemLink(props: NavBarItemLinkProps) {
    const {to, text, icon} = props
    return (
        <li className="navbaritem-link">
            <Link to={to}>
                {icon ? icon : null}
                {text ? <p>{text}</p> : null}
            </Link>
        </li>
    );
}

export default NavBarItemLink;
